// src/MyChatFullscreen.jsx
import React, {useEffect, useRef, useState} from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from '@mui/icons-material/Replay';
import {Button, useMediaQuery} from '@mui/material';
import { useTheme } from '@mui/material/styles';

function MyChatFullscreen({ onClose, onRefresh, onFeedback, subtitle}) {
    const chatContainerRef = useRef(null);
    const theme = useTheme();
    // For example, consider mobile screens below 600px
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    const buttonContainerStyle = {
        position: 'absolute',
        display: 'flex',
        top: 20,
        right: 0,
        paddingRight: '20px',
        marginTop: isMobile ? '70px' : '0px',
        gap: '20px',
        zIndex: 10000,
    };

    useEffect(() => {
        createChat({
            webhookUrl: 'https://dev.api.foxid.com.br/webhook/3a45f7ca-a7c1-4cfe-8642-83831f607202/chat',
            mode: 'fullscreen',
            target: chatContainerRef.current,
            defaultLanguage: 'pt',
            showWelcomeScreen: false,
            initialMessages: [],
            i18n: {
                pt: {
                    title: 'ABES ChatBOT',
                    subtitle: subtitle,
                    inputPlaceholder: 'Escreva sua pergunta :)',
                },
            },
        });
    }, []);

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#fff',
                zIndex: 9999,
                overflow: 'hidden',
            }}
        >
            <div style={buttonContainerStyle}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onFeedback}
                    className ="pulseFeedback"
                    style={{

                        backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent background
                        color: 'darkgray',
                        marginRight: '0px',
                    }}
                >
                    <p style={{ padding: 0, margin: '0 0px 0 0' }}>Feedback</p>
                </Button>

                {/* Nova Conversa Button */}
                <Button
                    variant="contained"
                    color="error"
                    onClick={onRefresh}
                    style={{

                        backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent background
                        color: 'darkgray', // Icon color
                        marginRight: '0px',
                    }}
                >
                    <p style={{ padding: 0, margin: '0 10px 0 0' }}>Nova Conversa</p>
                    <ReplayIcon />
                </Button>
                {/* Close Button */}
                <Button
                    variant="contained"
                    color="error"
                    onClick={onClose}
                    style={{

                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        color: 'darkgray',
                    }}
                >
                    <CloseIcon />
                </Button>
            </div>


            {/* Chat container */}
            <div
                ref={chatContainerRef}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            />
        </div>
    );
}

export default MyChatFullscreen;
